import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as dayjs from 'dayjs';
import * as isBetween from 'dayjs/plugin/isBetween';
import { MaintenanceService, ScheduledMaintenance } from '../service/maintenance.service';
import { filter, switchMap } from 'rxjs/operators';

dayjs.extend(isBetween);
@Component({
  standalone: false,
  selector: 'maintenance-mode-banner',
  templateUrl: './maintenance-mode-banner.component.html',
  styleUrls: ['./maintenance-mode-banner.component.scss'],
})
export class MaintenanceModeBannerComponent implements OnInit {
  @Input() appName = 'This application';

  scheduled: ScheduledMaintenance;
  bannerVisible = false;

  constructor(private maintenanceService: MaintenanceService, private router: Router) {
    this.scheduled = {
      active: false,
      endsAfterNow: false,
      end: undefined,
      start: undefined,
    };
  }

  async ngOnInit() {
    await this.updateVisibility();

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(async () => await this.updateVisibility());
  }

  async updateVisibility() {
    this.scheduled = await this.maintenanceService.scheduledMaintenance();
    this.bannerVisible = this.scheduled.endsAfterNow && !this.maintenanceService.bannerDismissed;
  }

  // get formattedBannerMessage(): string {
  //   if (!this.scheduled.start || !this.scheduled.end) {
  //     return '';
  //   }

  //   const dayStart = dayjs(this.scheduled.start);
  //   const dayEnd = dayjs(this.scheduled.end);
  //   const now = dayjs();

  //   const duration = Math.max(1, dayEnd.diff(dayStart, 'hour', false));
  //   const startDateFormatted = dayStart.format('dddd, MMMM D, YYYY h:mm A');
  //   const endDateFormatted = dayEnd.format('dddd, MMMM D, YYYY h:mm A');
  //   // console.log(duration);
  //   const timeUnit = duration == 1 ? 'hour' : 'hours';

  //   const isInWindow = now.isBetween(dayStart, dayEnd, 'minute');

  //   return isInWindow
  //     ? `Currently scheduled maintenance.  ${this.appName} will be offline until ${endDateFormatted}`
  //     : `Upcoming scheduled maintenance.  ${this.appName} will be offline on ${startDateFormatted} for ${duration} ${timeUnit}`;
  // }

  //Updated method that includes minutes (so instead of 1.5 hours showing as 1 hour, it will show 1 hour and 30 minutes)
  get formattedBannerMessage(): string {
    if (!this.scheduled.start || !this.scheduled.end) {
      return '';
    }

    const dayStart = dayjs(this.scheduled.start);
    const dayEnd = dayjs(this.scheduled.end);
    const now = dayjs();

    const totalMinutes = dayEnd.diff(dayStart, 'minute');
    const safeMinutes = Math.max(60, totalMinutes); // enforce minimum 1 hour

    const hours = Math.floor(safeMinutes / 60);
    const minutes = safeMinutes % 60;

    const startDateFormatted = dayStart.format('dddd, MMMM D, YYYY h:mm A');
    const endDateFormatted = dayEnd.format('dddd, MMMM D, YYYY h:mm A');

    const durationLabel =
      minutes === 0
        ? `${hours} ${hours === 1 ? 'hour' : 'hours'}`
        : `${hours} ${hours === 1 ? 'hour' : 'hours'} ${minutes} minutes`;

    const isInWindow = now.isBetween(dayStart, dayEnd, 'minute');

    return isInWindow
      ? `Currently scheduled maintenance. ${this.appName} will be offline until ${endDateFormatted}`
      : `Upcoming scheduled maintenance. ${this.appName} will be offline on ${startDateFormatted} for ${durationLabel}`;
  }

  handleDismiss() {
    this.maintenanceService.dismissBanner();
    this.bannerVisible = false;
  }
}
